export const normaliseSelectedOptions = (value) => {
  if (!value) return [];

  if (typeof value === "string") {
    try {
      return normaliseSelectedOptions(JSON.parse(value));
    } catch {
      return [];
    }
  }

  if (Array.isArray(value)) return value;
  if (typeof value !== "object") return [];

  return Object.entries(value).map(([fieldKey, option]) =>
    option && typeof option === "object"
      ? { field_key: fieldKey, ...option }
      : { field_key: fieldKey, value: option }
  );
};

const isQuantityIdentifier = (value) => {
  const tokens = String(value ?? "")
    .trim()
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);

  return tokens.includes("quantity") || tokens.includes("qty");
};

export const getOptionTemplateQuantity = (item) => {
  const quantityOption = normaliseSelectedOptions(item?.selected_options).find(
    (option) =>
      isQuantityIdentifier(option?.field_key) ||
      isQuantityIdentifier(option?.field_name) ||
      isQuantityIdentifier(option?.template_key) ||
      isQuantityIdentifier(option?.template_name)
  );

  if (!quantityOption) return "1";

  const selectedValue = [
    quantityOption.label,
    quantityOption.value,
    quantityOption.value_key,
  ].find(
    (value) =>
      value !== undefined && value !== null && String(value).trim() !== ""
  );

  return selectedValue === undefined ? "1" : String(selectedValue).trim();
};
